window.Products.HomeDecor.BedPillowSham = function() {};
window.Products.HomeDecor.BedPillowSham.inherits(window.Products.HomeDecor.HomeDecor);
window.Products.HomeDecor.BedPillowSham.id = 89;
window.Products.HomeDecor.BedPillowSham.slug = 'bed-pillow-sham';
window.Products.HomeDecor.BedPillowSham.has_3d = true;
window.Products.HomeDecor.BedPillowSham.has_subproducts = true;
window.Products.HomeDecor.BedPillowSham.use_glb = true;
window.Products.HomeDecor.BedPillowSham.prototype.designObject = 0;

window.Products.HomeDecor.BedPillowSham.prototype.set3dProperties = function(modelViewer) {
	var me = this;

	modelViewer.initalCameraPosition.z = -4;
	modelViewer.setFixedView('front');

	me.loadEnvMap(function(){
		for(var i = 0; i < modelViewer.object.children.length; i++){
			if(!modelViewer.object.children[i].material) continue;
			modelViewer.object.children[i].material.envMap = me.envMap;
			modelViewer.object.children[i].material.envMap.mapping = THREE.EquirectangularReflectionMapping;
			modelViewer.object.children[i].material.needsUpdate = true;
			modelViewer.object.children[i].material.envMap.needsUpdate = true;
		}

		me.updateThreeTexture(modelViewer);
	});
};

window.Products.HomeDecor.BedPillowSham.prototype.setThreeControls = function(controls) {
	controls.minDistance = 3.0;
	controls.maxDistance = 4.0;
};

window.Products.HomeDecor.BedPillowSham.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[0].children[this.designObject].material.map = modelViewer.texture;
	modelViewer.object.children[0].children[this.designObject].material.map.flipY = false;
	modelViewer.object.children[0].children[this.designObject].material.needsUpdate = true;
};